var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('h1',[_vm._v("Game Over")]),_c('button',{on:{"click":_vm.restart}},[_vm._v("Start new game")])])}
var staticRenderFns = []

export { render, staticRenderFns }